import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
    Card,
    CardHeader,
    CardContent,
    Avatar,
} from '@material-ui/core';
import { UPDATE_BREAK_RULE_SET } from '../../../store/ruleSet';
import BreakCalculation from './BreakCalculation';

/**
 * @param {{validationErrors: {[Key: string] : boolean, isDisabled: boolean }, isDisabled: boolean, stepNumber: number}} props
 */
export default function BreakRuleSection(props) {
    const { validationErrors, isDisabled, stepNumber, } = props;
    const { t } = useTranslation('employmentBillboard', { keyPrefix: 'settings.ruleSet.breakRuleStep' });
    const dispatch = useDispatch();
    /** @type {EmploymentBillboard.AdminStore} */
    // @ts-ignore
    const { adminRuleSet } = useSelector((state) => state);

    /**
     * @param {string} target
     * @param {string} value
     */
    const updateBreakRulesStore = (target, value) => {
        dispatch({
            type: UPDATE_BREAK_RULE_SET,
            payload: {
                [target]: value,
            },
        });
    };

    const generateErrorMessage = (errorKey) => {
        return validationErrors[errorKey] && (
          <span style={{ color: 'red', display: 'block' }}>{t(errorKey)}</span>
        );
    };

    return (
        <Card className="card">
            <CardHeader
                className="card--header"
                gutterbottom
                avatar={<Avatar className="avatar">{stepNumber}</Avatar>}
                title={t('title')}
            />
            <CardContent>
                <BreakCalculation 
                    breakRules={adminRuleSet.breakRules}
                    handleChangeSetting={updateBreakRulesStore}
                    disabled={isDisabled}
                />
                {generateErrorMessage('noBreakRuleCondition')}
                {generateErrorMessage('noBreakRuleSameConditionAndShiftDuration')}
            </CardContent>
        </Card>

    );
}
